import * as React from 'react'

import { mbusinessApi } from 'redux/services/mbusiness'
import { GetMbusinessParams } from 'redux/services/mbusiness/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { MBUSINESS_STATUS_TEXT } from 'constants/mbusiness'
import { Mbusiness } from 'models/mbusiness'

import { formatDate } from 'shared/libs'
import { EmptyDetails } from 'shared/ui'

import { Details } from './components/Details'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

export const MbusinessPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    Mbusiness['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetMbusinessParams>({
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = mbusinessApi.useLazyGetMbusinessQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetMbusinessParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="МБизнес"
        header={<Filters onSubmit={onChangeFilters} />}
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                  width: 100,
                },
                {
                  data: 'Название',
                  key: 'name',
                  width: 50,
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  width: 50,
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'JIRA',
                  key: 'jira_key',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  width: 50,
                  render: (_, item) => MBUSINESS_STATUS_TEXT[item.status],
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
